export function PlanBadge({ plan }: { plan: string | null | undefined }) {
  const label = plan === "plus" ? "PLUS" : (plan || "free").toUpperCase();
  const cls = plan === "pro" || plan === "plus" ? "badge badge-pro" : "badge";
  return <span className={cls}>{label}</span>;
}

export function RoleBadge({ role }: { role: string | null | undefined }) {
  if (role !== "admin") return null;
  return <span className="badge badge-admin">ADMIN</span>;
}
